import type { Plugin } from 'yet-another-react-lightbox';
import { createModule, isImageSlide, PLUGIN_ZOOM } from 'yet-another-react-lightbox';
import { resolveZoomProps } from './props';
import { ZoomContextProvider } from './ZoomController';
import { ZoomWrapper } from './ZoomWrapper';
import { ZoomLevel } from './ZoomLevel';

/** Zoom plugin */
export const Zoom: Plugin = ({ augment, addModule }) => {
  augment(({ zoom: zoomProps, render, controller, ...restProps }) => {
    const zoom = resolveZoomProps(zoomProps);
    return {
      zoom,
      render: {
        ...render,
        slide: (props) =>
          isImageSlide(props.slide) ? (
            <ZoomWrapper render={render} {...props} />
          ) : (
            render.slide?.(props)
          ),
        slideHeader: (_) => (
          <>
            {render.slideHeader?.(_)}
            <ZoomLevel />
          </>
        ),
      },
      controller: { ...controller, preventDefaultWheelY: zoom.scrollToZoom },
      ...restProps,
    };
  });

  addModule(createModule(PLUGIN_ZOOM, ZoomContextProvider));
};
